/**
 * 暫定的に、最も汎用的なメッセージと思われるものに変数名を付けている。
 * 今後、他のメッセージが増えていった時に適切にに変数名や変数の管理方法（コードなど）を検討しなおすこと。
 * またエラーメッセージの型管理も検討する。
 * @see https://github.com/my-color/front/pull/6009#discussion_r775700223
 */
export const normalErrorMessage = 'エラーが発生しました。※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
